import React from 'react';
import BusinessPortfolioManager from '../../../components/BusinessPortfolioManager';

export default function BusinessTab({ userId }) {
  return <BusinessPortfolioManager userId={userId} />;
}
